import { Button } from '@mantine/core';
import { Link } from 'react-router-dom';
import { EmptyState } from '@/components/EmptyState';

export function NotFoundPage() {
  return (
    <EmptyState
      title="Page not found"
      action={
        <Button component={Link} to="/programmes" variant="default">
          Go to programmes
        </Button>
      }
    >
      That address doesn’t match anything in the admin.
    </EmptyState>
  );
}
